import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data: any) {
  const response = await http.postData("/mcu-ims", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http.putData(`/mcu-ims/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/mcu-ims`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByPasien(rm: string) {
  const response = await http.getData(`/pasien/${rm}/mcu-ims`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getList(filters: Record<string, any> = {}) {
  const qs = new URLSearchParams(filters as any).toString();
  const url = `/mcu-ims${qs ? "?" + qs : ""}`;
  const response = await http.getData(url).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/mcu-ims/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getMasters() {
  const response = await http.getData(`/mcu-ims/masters`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(
  id: number,
  data: { password: string; finalize_override_reason?: string }
) {
  // Catatan: caller menangani 422 (gate pemeriksa belum lengkap) tanpa alert global.
  const response = await http.putData(`/mcu-ims/${id}/sign-dpjp`, data).catch(err => {
    if (err?.response?.status !== 422) {
      ErrorAlert.showErrorAlert(err);
    }
    return Promise.reject(err);
  });
  return response;
}

/* ============ Section pemeriksa (sinkronisasi multi-pemeriksa) ============ */

async function getSections(id: number) {
  const response = await http.getData(`/mcu-ims/${id}/sections`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function addSection(id: number, data: any) {
  const response = await http.postData(`/mcu-ims/${id}/sections`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function assignSection(sectionId: number, assigned_user_id: number | null) {
  const response = await http
    .putData(`/mcu-ims/sections/${sectionId}/assign`, { assigned_user_id })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateSection(sectionId: number, data: any) {
  const response = await http
    .putData(`/mcu-ims/sections/${sectionId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signSection(sectionId: number, data: { password: string }) {
  const response = await http
    .putData(`/mcu-ims/sections/${sectionId}/sign`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteSection(sectionId: number) {
  const response = await http
    .deleteData(`/mcu-ims/sections/${sectionId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function searchDokter(term: string) {
  const qs = new URLSearchParams({ term }).toString();
  const response = await http
    .getData(`/tim-penguji-kesehatan/cari-dokter?${qs}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function markPeserta(id: number) {
  const response = await http.putData(`/mcu-ims/${id}/mark-peserta`, {}).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/mcu-ims/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id: number) {
  window.open(`${http.getAPI()}/mcu-ims/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  getByPasien,
  getList,
  find,
  getMasters,
  signDpjp,
  markPeserta,
  destroy,
  print,
  getSections,
  addSection,
  assignSection,
  updateSection,
  signSection,
  deleteSection,
  searchDokter
};
